import { UsersWrapper } from "./users-wrapper";

export default function UsersPage() {
  return <UsersWrapper />;
}
